import React, { Component } from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import 'react-calendar/dist/Calendar.css';
import WhatsApp from '../assets/img/WhatsApp_Logo.png';
import MobNavbar from './js/BottomNav';
import { isMobile } from 'react-device-detect';
import './css/TotalEMI.css';
import TopNavbar from 'ipos/js/ProfileTopbar';
import {connect}  from  "react-redux";


class IposHelp extends Component {
    constructor(props) {
        super(props);
        this.state = {
           
            startDate: new Date(),
            name: 'React',
            monthpick: { display: "none" },
            daypick: { display: "none" },
            buttongen: { display: "none" },
            uploadDropdown: true,
            isDisabled: true,
            availableReport: false,
            s_date: '',
            e_date: '',

        };

    }


    // onChange = date => { this.setState({startDate: date }); };
    handleChange = date => {
        this.setState({
            startDate: date
        });
    };

   

    componentDidMount() {
        this.props.currentMenu("totalemi");
    }


    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }
   

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }



    render() {

        return (
            <>
            { isMobile &&  <TopNavbar/> }
              <div className="fixed-content" style={{minHeight:'90%'}}>

                <div className="container-fluid ">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12 p-top-10">
                           
                            <div className="content">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                          <div className="card">
                                             <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center" style={{borderBottom:'1px solid darkgray'}} >
                                                   <h4 style={{color:'#666666',fontSize:'120%'}}>Need Help?</h4>
                                             </div>

                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ textAlign: '-webkit-center' ,padding:'10px'}}>
                                                <img className="help" src={WhatsApp} style={{height:'50px'}}/>
                                              
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                            <h4 className="title"><strong>For Support, WhatsApp</strong></h4>
                                                </div>

                                            <div className="content text-center">
                                                <h4 className="title" style={{ color: "darkorange" }}><b>734901234</b></h4>
                                                <p>7:00 AM - 11:00 PM (7 days)</p>
                                            </div>
                                       </div>
                                 </div>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
             
            </div>
           
           </>
        );
    }
}


const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(IposHelp);